<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Reschedule Consultation",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         const datetime_now = moment().format("YYYY-MM-DD HH:mm:ss");
         const week_date = moment().add(2, 'days').format("YYYY-MM-DD");
         
         return {
            title: "Reschedule Consultation",
            items: [
               {
                  text: "Consultation",
                  href: "/consultations",
               },
               {
                  text: "Reschedule",
                  active: true,
               },        
            ],

            consultation: {
               id: '',
               booking_date: '',
               consultation_type: '',
               doctor_session_id: '',
               day_id: '',
               start_time: '',
               end_time: '',
               token: '',

               video_slot: '',
               clinic_slot: '',
               home_slot: '',
               consultation_for:'',
            },

            patients: [],
            patient_visible: false,
            patient_keyword: '',
            patient_id: '',


            doctors: [],
            members:[],
            doctor_visible: false,
            doctor_keyword: '',
            doctor_id: '',

            clinic_schedules: [],
            clinic_slots: [],

            home_schedules: [],
            home_slots: [],

            video_schedules: [],
            video_slots: [],
            errors: {},

            now: datetime_now,
            today: current_date,
            week: week_date,
            loading: false,
         };
      },
      mounted() {
         this.doctorDetails();
         // this.fetchMembers();
      },

      created() {
         this.fetchMembers();

      },

      methods: {

         doctorDetails() {
            let url = "api/admin/doctors/details?doctor_id=" + this.$route.params.doctor_id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.no_days = responseData.doctor.no_days_booking;
               this.week = moment().add(this.no_days, 'days').format("YYYY-MM-DD"); 
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchMembers() {  
            let url = "api/admin/consultations/getMembers?patient_id=" + this.$route.params.patient_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.members = responseData.members;
                  this.member_visible = true;
                  
               })
               .catch((err) => console.log(err));
         },
         fetchSchedules() { 
            if(this.consultation.booking_date) {
               let url = "clinic/consultation/clinic_scheduleNew?doctor_id=" + this.$route.params.doctor_id + "&date=" + this.consultation.booking_date;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);

                     this.clinic_schedules = responseData.clinic_schedules;
                     this.clinic_slots = responseData.clinic_slots[0];

                     this.home_schedules = responseData.home_schedules;
                     this.home_slots = responseData.home_slots[0];

                     this.video_schedules = responseData.video_schedules;
                     this.video_slots = responseData.video_slots[0];

                     // if booking date is current date, display time slots only after the current time starts here
                     var now_plus_one = moment().add(1,'hours').format("YYYY-MM-DD HH:mm:ss");

                     if(this.consultation.booking_date==this.today) {
                        for(var i=0; i<this.video_slots.length; i++) {
                           var start_time = this.consultation.booking_date + " " + this.video_slots[i].start;
                           if(start_time <= now_plus_one) {
                              this.video_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.home_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.home_slots[i].start;
                           if(start_time <= now_plus_one) {
                              this.home_slots[i].dnone = true;
                           }
                        }

                        for(i=0; i<this.clinic_slots.length; i++) {
                           start_time = this.consultation.booking_date + " " + this.clinic_slots[i].start;
                           if(start_time <= now_plus_one) {
                              this.clinic_slots[i].dnone = true;
                           }
                        }
                     } // ends here

                     console.log(this.home_slots);
                     
                  })
                  .catch((err) => console.log(err));
            }
            
         },    

         clearSlots() {
            this.consultation.video_slot = '';
            this.consultation.home_slot = '';
            this.consultation.clinic_slot = '';
         },

         addConsultation() {
            if(this.patient_id && !this.clinic_slots.length && this.consultation.doctor_id && this.consultation.booking_date){
               this.$swal("", "No slots available", "error");
               this.errors = {};            
            }else{
           

               let slot = ''; 

            if(this.consultation.clinic_slot) {
               slot = this.consultation.clinic_slot.split("-"); 
               this.consultation.day_id = this.clinic_schedules[0][0].day_id;
            }

            if(slot) {
               this.consultation.start_time = slot[0];
               this.consultation.end_time = slot[1];
               this.consultation.doctor_session_id = slot[2];
               this.consultation.token = slot[3];
               this.consultation.schedule_start = slot[4];
               this.consultation.schedule_end = slot[5];
            }
           
            console.log(slot);
            console.log(this.consultation.day_id);

            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/consultation/reschedule";  
       
            let formData = new FormData();

            formData.append("id", this.$route.params.id); 
            // formData.append("session_id", this.consultation.doctor_session_id);
            formData.append("doctor_id", this.$route.params.doctor_id); 
            formData.append("patient_id", this.$route.params.patient_id); 
            if(this.$route.params.clinic_id){
               formData.append("clinic_id", this.$route.params.clinic_id); 
            }else{
               formData.append("clinic_id", ''); 
            }
            formData.append("consultation_type", this.$route.params.type); 
            formData.append("member_id", this.consultation.consultation_for); 
            formData.append("booking_date", this.consultation.booking_date); 
            formData.append("consultation_start_time", this.consultation.start_time);
            formData.append("consultation_end_time", this.consultation.end_time);
            formData.append("schedule_start", this.consultation.schedule_start);
            formData.append("schedule_end", this.consultation.schedule_end); 
            formData.append("day_id", this.consultation.day_id); 
            formData.append("token", this.consultation.token); 
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  //this.clearForm();
                  this.$router.push({ name: 'consultations'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {

                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }
      },
      }
   }
</script>

<style type="text/css">
   .slots label.btn {
      border-radius: 5px !important;
      margin-right: 10px;
      margin-bottom: 10px;
   }

   .slots {
      display: inline;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'consultations' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addConsultation()">
                        
                        <div class="row mb-3">

                           <div class="form-group col-md-4">
                              <label>Date <span class="text-danger">*</span></label>
                              <input type="date" class="form-control" v-model="consultation.booking_date" @change="fetchSchedules()" v-bind:class="{ 'is-invalid': Boolean(errors.booking_date) }" :min="today" :max="week"/>
                              <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div> 
                           <div class="form-group col-md-6" >
                              <label>Consultation For <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="consultation.consultation_for" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_for) }">
                                 <option value="">Self</option>
                                 <option :value="member.id" v-for="member in members" :key="member.id">{{member.name}}</option>
                              </select>
                           </div>  

                        </div>

                        <b-card v-if="consultation.booking_date" header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 border border-top-0 border-start-0 border-end-0 pb-3 mb-3">
                              Consultation Type: 
                              <span v-if="$route.params.type==1">Video</span>
                              <span v-if="$route.params.type==2">Home</span>
                              <span v-if="$route.params.type==3">Clinic</span>                     
                              
                           </h4>

                           <!-- <b-form-radio-group 
                                 v-model="consultation.consultation_type"
                                 name="consultation_type"
                                 @change="clearSlots()"
                              >        
                              <div class="row">
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="1">Video Consultation</b-form-radio>  
                                 </div>   
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="2">Home Consultation</b-form-radio> 
                                 </div>   
                                 <div class="form-group col-md-4">                        
                                    <b-form-radio value="3">Clinic Consultation</b-form-radio>   
                                 </div>                        
                              </div>
                           </b-form-radio-group> -->

                           <div class="row">
                              <div class="col-12">
                                 <div v-if="$route.params.type==1">
                                    <div v-if="video_slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }">
                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.video_slot"
                                          name="video_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                       >  
                                          <b-form-radio v-for="(slot, index) in video_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end"  :disabled="!slot.slot_available || slot.dnone">{{slot.start | formatTime}} - {{slot.stop | formatTime}}</b-form-radio>  
                                       </b-form-radio-group>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                                    <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </div>

                                 <div v-if="$route.params.type==2">
                                    <div v-if="home_slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }">
                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.home_slot"
                                          name="home_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                       >  
                                          <b-form-radio v-for="(slot, index) in home_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end"  :disabled="!slot.slot_available || slot.dnone">{{slot.start | formatTime}} - {{slot.stop | formatTime}}</b-form-radio>  
                                       </b-form-radio-group>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                                    <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </div>

                                 <div v-if="$route.params.type==3">
                                    <div v-if="clinic_slots.length" v-bind:class="{ 'is-invalid': Boolean(errors.session_id) }">
                                       <label class="w-100">Pick your slot <span class="text-danger">*</span></label>
                                       <b-form-radio-group 
                                          v-model="consultation.clinic_slot"
                                          name="clinic_slot"
                                          buttons
                                          button-variant="outline-primary"
                                          size="sm"
                                          class="slots"
                                       >  
                                          <b-form-radio v-for="(slot, index) in clinic_slots" :key="index" :value="slot.start + '-' + slot.stop + '-' + slot.schedule_id + '-' + slot.token + '-' + slot.schedule_start + '-' + slot.schedule_end"  :disabled="!slot.slot_available || slot.dnone">{{slot.start | formatTime}} - {{slot.stop | formatTime}}</b-form-radio>  
                                       </b-form-radio-group>
                                    </div>
                                    <div v-else>
                                       <p class="text-danger">No available slots</p>
                                    </div>
                                    <div v-for="(val, index) in errors.session_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>  
                                 </div>
                              </div>
                           </div>
                        </b-card>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'consultations' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
